import Mynavbar from "./components/navbar";
import Footer from "./components/Footer";
import Myhomeboot from "./components/Homeboot";
import About from "./About";
import Gallery from "./components/Gallery";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Team from "./components/team/Team";
import Videos from "./components/Videos/Videos"

function App() {
  return (
    <Router>
      <div>
        <Mynavbar />
        <Routes>
          <Route path="/" element={<Myhomeboot />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/about" element={<About />} />
          <Route path="/team" element={<Team />} />
          <Route path="/videos" element={<Videos />} />
       
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
